import {useEffect, useState} from "react";
import {findUnattendedAccessTermsAcceptancesWithPagination} from "../api/unattendedAccessTermsAcceptanceApiClient";

export const useUnattendedAccessTermsAcceptances = (page, pageSize, reloadTrigger) => {
    const [customerUnattendedAccessTermsAcceptances, setCustomerUnattendedAccessTermsAcceptances] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const unattendedAccessTermsAcceptancesWithPagination = findUnattendedAccessTermsAcceptancesWithPagination(page, pageSize, abortController.signal);

        unattendedAccessTermsAcceptancesWithPagination
            .then(
                (data) => {
                    const customerUnattendedAccessTermsAcceptances = data.customerUnattendedAccessTermsAcceptances;
                    const pagination = data.pagination;

                    setCustomerUnattendedAccessTermsAcceptances(customerUnattendedAccessTermsAcceptances)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, reloadTrigger]);

    return {customerUnattendedAccessTermsAcceptances : customerUnattendedAccessTermsAcceptances, pagination};
};
